const messages = {
  nomeUni: " Pontificia Istituto Patristicum Augustinianum",
  email: "E-mail",
  password: "Password",
  testoLogo: "testoLogo",
  semestre: "Semestre",
  NonDefinito: "-- Non Definito --",
  carattereNonValido: "Hai inserito un carattere non valido!",
  presentazione:
    "Benvenuto nella pagina di immatricolazione per l'anno accademico {annoaccaS}/{annoaccaF}",
  cardCompleta: "Completato",
  cardDaCompletare: "Da Completare",
  conferma: "Conferma",
  chiudi: "Chiudi",
  avanti: "Avanti",
  indietro: "Indietro",
  campiObbligatori: "* Indica campi obbligatori",
  campoObbligatorio: "Campo obbligatorio",
  checkCampiObbligatori: "Compilare tutti i campi obbligatori!",
  tastoStep: { compila: "Compila", modifica: "Modifica" },
  si: "SI",
  no: "NO",
  errore: "Attenzione! Si è verificato una errore.",
  chiuse:
    "Attenzione, le immatricolazioni sono chiuse, consultare il calendario sul sito dell'Università.",
  salva: "Salva",
  stepCompilati_1: "Hai compilato",
  stepCompilati_2: "schede su {step}",
  stepCompletati:
    "Hai compilato tutte le schede. Ora clicca sul tasto registrazione per inviare la richiesta di immatricolazione",
  noData: "Nessun risultato trovato!",
  login: {
    confermaReset:
      "Se i dati inseriti sono corretti, entro pochi minuti riceverai la nuova password al tuo indirizzo di posta elettronica!",
    nuovoStudente: {
      titolo: "Sei un nuovo studente?",
      testo:
        'Se vuoi iniziare la procedura di Immatricolazione all\'Università, clicca sul tasto "REGISTRATI" ed inserisci la tua mail. Riceverai al tuo indirizzo di posta elettronica la password di accesso, con cui potrai accedere alla compilazione della scheda.',
    },

    vecchioStudente: {
      titolo: "Sei già uno studente del Patristicum?",
      testo:
        "Se sei uno studente del Patristicum e hai un numero di matricola, clicca qui:",
    },
    titolo: "Accedi alla tua scheda di Immatricolazione",
    accedi: "Accedi",
    forgotPassword: "Password dimenticata?",
    noRegistrato: "Non sei ancora registrato?",
    registrati: "Registrati",
    recuperoPassword: "Recupero della password",
    recuperoPasswordLabel:
      "Inserisci l'indirizzo email con cui ti sei registrato *",
    registrazioneUtente:
      "Inserisci il tuo indirizzo di posta elettronica, ti invieremo le credenziali per accedere alla procedura di immatricolazione",
    registrazioneUtenteConferma:
      "Ti abbiamo inviato una email, controlla la tua casella di posta elettronica!",
    registrazioneUtenteEmailEsistente: "Email già registrata",
    recupera: "Recupera",
    emailNonValida: "Formato dell' email non valido!",
    loginErrato: "Email o password non corretti!",
    domandaInLavorazione:
      "La tua richiesta di immatricolazione è in lavorazione. Non è possibile effettuare modifiche.",
    statoPresentata:
      "Risulta già registrata una richiesta di immatricolazione.<br> L'eventuale invio di una nuova richiesta comporterà la cancellazione della precedente.",
  },

  logOut: {
    domanda: "Vuoi chiudere l'applicazione?",
    nota:
      "<b>Ricordati di salvare, o perderai tutte le informazioni inserite.</b>",
  },
  istruzioni: {
    tasto: "Istruzioni",
    esci: "Esci dalla guida",
    avanti: "Avanti",
    indietro: "Indietro",
    fine: "Fine della guida",
    step1: "Inizia qui compilando la prima scheda",
    step2:
      "Se vuoi, puoi salvare temporaneamente i tuoi dati. Potrai completare la tua richiesta di immatricolazione in un secondo momento! ",
    step3:
      "Una volta completate tutte le schede, potrai inviare la tua richiesta di immatricolazione",
  },

  introduzione: {
    titolo: "Norme e Condizioni",
    testo_iniziale:
      "Per proseguire è necessario il consenso al trattamento dei dati conformemente alle disposizioni normative vigenti, ivi incluse quelle in materia di protezione dei dati personali (Regolamento Europeo 679/2016)",
    testo_consenso:
      "<br>Consenso al trattamento in rapporto alle finalità esplicitate al punto 2) lettere a) b) c) d) della Informativa ai sensi dell’art. 13 del Regolamento Europeo 679/2016.<br>Il sottoscritto acconsente al trattamento dei dati personali che lo riguardano, in rapporto alle seguenti finalità (barrare la finalità per cui il consenso viene esplicitato):",
    tasto_informativa:
      "Informativa ai sensi dell'art. 13 del Regolamento Europeo 679/2016",
    consenso1:
      "adempimento degli obblighi contrattuali assunti dall’Università Gregoriana nei miei confronti (obbligatorio);",
    consenso2:
      "adempimento degli obblighi di natura legale, fiscale e statutaria connessi, o comunque derivanti, dalla mia iscrizione presso l’Università Gregoriana (obbligatorio);",
    consenso3:
      "di pubblicazione all’interno dei documenti ufficiali dell’Università quali: annuario degli studenti, Ordo Anni Accademici, Liber Annualis, inaugurazione dell’anno accademico;",
    consenso4:
      "pubblicitaria, in relazione all’organizzazione di iniziative di carattere benefico, convegni, seminari, corsi di studio gestiti, o patrocinati o in altro modo sponsorizzati o promossi, da parte dell’Università Gregoriana.",
    consenso_norme_condotta:
      "Norme di condotta nel caso di molestie sessuali e morali.",
    conferma: "Ho capito",
  },

  anagrafica: {
    titolo: "Dati Anagrafici",
    cognome: "Cognome",
    nome: "Nome",
    datanascita: "Data di Nascita (gg/mm/aaaa)",
    nazionenascita: "Nazione di Nascita",
    comunenascita: "Comune di Nascita",
    statocivile: "Stato Civile",
    linguamadre: "Lingua Madre",
    sesso: "Sesso",
    religione: "Religione",
    cittadinanza: "Cittadinanza",
    "2cittadinanza": "2a Cittadinanza",
    ordinereligioso: "Ordine Religioso",
    codicefiscale: "Codice Fiscale",
    fototessera: "Upload Fototessera",
    fototesseraInfo: "Carica un'immagine formato JPG",
    CFNoValido: "Codice Fiscale non valido",
    copiaResidenza: "Copia i dati dalla Residenza",
    diocesi: "Diocesi",
    collegio: "Collegio",
  },

  indirizzi: {
    titolo: "Inserisci i tuoi recapiti",
    titoloResidenza: "Residenza nel Paese di origine",
    titoloRecapito: "Domicilio",
    cap: "CAP",
    nazione: "Nazione",
    comune: "Comune",
    telefono: "Telefono",
    indirizzo: "Indirizzo",
    presso: "Presso",
    cellulare: "N° di cellulare",
    formatoCap: "Formato non corretto!",
  },

  studiprevi: {
    titolo: "Studi previ e conoscenza delle lingue",
    studiPreuni: "Studi pre-universitari",
    studiFilosofia: "Studi di Filosofia",
    studiTeologia: "Studi di Teologia",
    studiAltro: "Altri Studi (Lettere, Diritto, Storia, Psicologia, ecc.)",
    titoloStudio: "Titolo di studio",
    istituto: "Istituto",
    anno: "Anno di conseguimento",
    votazione: "Votazione",
    lingue: {
      titolo: "Conoscenza delle lingue",
      antiche: "Lingue antiche",
      latina: "Latina",
      greca: "Greca",
      ebraica: "Ebraica",
      moderne: "Lingue moderne",
      francese: "Francese",
      inglese: "Inglese",
      italiana: "Italiana",
      spagnola: "Spagnola",
      tedesca: "Tedesca",
      livello: {
        discreto: "Discreto",
        buono: "Buono",
        eccellente: "Eccellente",
      },
      reset: "Cancella",
    },
  },

  iscrizione: {
    titolo: "Scegli il Ciclo di Studi",
    facolta: "Facoltà",
    unita_accademica: "Unità Accademica",
    ciclo: "Ciclo di Studi",
    specializzazione: "Specializzazione",
    annodicorso: "Anno di corso",
    tipoiscrizione: "Tipo di iscrizione",
    categoria: "Categoria",
    domandaOspite: "Vuoi iscriverti come studente Ospite?",
    cambioIscrizione:
      "Attenzione, hai modificato la tua iscrizione.E' necessario confermare nuovamente il caricamento dei documenti e la scelta dei corsi.",
    infoCategoria:
      "Ospite è lo studente che frequenta solo qualche corso (max 3 per semestre)",
    infoAnnoCorso: "1 - Primo anno <br> 2 - Secondo anno <br> 3 - Terzo anno",
    infoIscrizione: "",
    scegliciclo: "Selezionare prima il ciclo di studi",
    sceglianno: "Selezionare prima il ciclo di studi",
    infoCategoriaORDSTR:
      "Straordinario è lo studente che non ha i requisiti necessari per ottenere un grado accademico",
    notaFacolta: "Nota della Facoltà",
    confermaNota: "Ho letto la Nota",
  },

  documenti: {
    titolo: "Carica i documenti necessari per l'immatricolazione",
    caricaFile: "Carica il file (formato {formato})",
    fileCaricato: "File caricato correttamente",
    fileObbligatorio: "Documento obbligatorio!",
    fileTooBig: "File troppo grande! (max 2 MB)",
    fileErrato: "Formato del file non corretto!",
    anteprima: "Anteprima",
    cancella: "Cancella",
    foto: "La tua foto",
    istruzioniFoto:
      "Muovi la cornice sottostante per inquadrare correttamente il tuo viso (puoi anche ingrandire l'immagine). Osserva l'anteprima del tuo badge nel box a destra. Per confermare la tua scelta clicca sul tasto 'CONFERMA'",
    anteprimaBadge: "Anteprima del Badge",
  },

  corsi: {
    seminariLettureChiuse:
      "Attenzione, le Iscrizioni sono terminate. Non è più possibile scegliere Seminari e Letture Guidate tramite la procedura on-line. In caso di necessità rivolgersi alla Segreteria di Facoltà",
    sem1: " (annuali o del 1° semestre)",
    sem2: " (2° semestre)",
    nonTrovato1Sem: "Corso inesistente o appartenente al 2° semestre",
    nonTrovato2Sem: "Corso inesistente o appartenente al 1° semestre",
    titolo: "Scelta dei corsi",
    corsi: "Corsi",
    seminari: "Seminari",
    letture: "Letture Guidate",
    preparazione: "Preparazione elenco corsi...Attendere",
    ricerca: "Ricerca (Corso, Docente, Titolo)",
    di: "di",
    nocorsi: "Non ci sono {tipocorso} per il ciclo di studi selezionato.",
    tuttiCorsi: "Visualizza i corsi di tutte le Facoltà",
    selezionati: "Selezionati",
    selezionatiOrdinati:
      "Per modificare l'ordine di preferenza trascinare la riga di interesse o cancellare il corso errato",
    obbligatori:
      "Il corso verrà inserito automaticamente nel tuo piano di studi",
    aggiungi: "Aggiungi",
    aggiunto: "Il corso &nbsp;<b>{corso}</b>&nbsp; è stato aggiunto!",
    giaScelto:
      "Attenzione! Il corso &nbsp;<b>{corso}</b>&nbsp; è già stato scelto!",
    cancellazione: "Vuoi cancellare il corso {corso} ?",
    attenzione: "Attenzione!",
    maxCorsi:
      "Hai raggiunto il numero massimo di corsi selezionabili per il percorso di studi scelto.",
    maxSeminari:
      "Hai raggiunto il numero massimo di seminari selezionabili per il percorso di studi scelto.",
    maxLetture:
      "Hai raggiunto il numero massimo di letture guidate selezionabili per il percorso di studi scelto.",
    minCorsi:
      "Devi scegliere ancora n°{corsi} corso| Devi scegliere ancora n°{corsi} corsi",
    minCorsiOK: "Hai scelto il numero minimo di corsi necessari!",
    minSeminari: "Devi scegliere ancora n°{corsi} seminari",
    minSeminariOK: "Hai scelto il numero minimo di seminari necessari!",
    minLetture: "Devi scegliere ancora n°{corsi} letture guidate",
    minLettureOK: "Hai scelto il numero minimo di letture guidate necessarie!",
    nessunaSelezione: "Nessun corso ancora selezionato!",
    noScelta:
      "Attenzione, per il ciclo di studi selezionato è necessario scegliere almeno {minCorsi} corsi!",
    troppiCorsi:
      "Attenzione, per il ciclo di studi selezionato è possibile scegliere un massimo di {maxCorsi} corsi!",
    noSceltaSeminari:
      "Attenzione, per il ciclo di studi selezionato è necessario scegliere almeno {minCorsi} seminari!",
    troppiSeminari:
      "Attenzione, per il ciclo di studi selezionato è possibile scegliere un massimo di {maxCorsi} seminari!",
    noSceltaLetture:
      "Attenzione, per il ciclo di studi selezionato è necessario scegliere almeno {minCorsi} letture guidate!",
    troppiLetture:
      "Attenzione, per il ciclo di studi selezionato è possibile scegliere un massimo di {maxCorsi} letture guidate!",
    corsiOspitiFuoriFacolta:
      "Attenzione, devi scegliere almeno un corso della Facoltà di: {facolta}",
    avvisoDogmatica:
      "Se questo semestre vuoi seguire un seminario, indica 3 scelte; se ne vuoi seguire due, aggiungi altre 3 scelte (totale 6 scelte per ordine di preferenza).",
  },

  invioRichiesta: {
    btnInvio: "INVIA LA RICHIESTA DI IMMATRICOLAZIONE",
    domanda: "Vuoi inviare la richiesta di Immatricolazione?",
    nota:
      "La Segreteria prenderà in carico la tua richiesta il prima possibile",
    btnConferma: "SI",
    btnAnnulla: "Annulla",
    fine: {
      titolo: "Hai terminato la procedura!",
      testo:
        "La tua richiesta è stata inviata. Tra qualche minuto riceverai un messaggio di posta elettronica con il riepilogo della tua richiesta di immatricolazione.",
    },
  },
  salvaDati: {
    info:
      "Salva temporaneamente i dati inseriti. Potrai continuire in un secondo momento la compilazione della scheda.",
    domanda: "Vuoi salvare le informazioni inserite fino a questo momento?",
    nota: "Potrai completare successivamente la raccolta dei tuoi dati.",
    btnConferma: "SI",
    btnAnnulla: "Annulla",
    fine: {
      titolo: "I dati sono stati salvati!",
      testo: "",
    },
  },
};

export default messages;
